import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/dialog-time-zone-options.hbs';
import profile_page_template from '@/../templates/profile.hbs';
import moment from 'moment-timezone';
import ide_settings from '@/models/ide_settings';
// helper to import the canonical timezones
import { a1 } from '@/views/helpers/canonical_time_zones';

var a2 = moment.tz.names();
var timezone = a1.filter(value => a2.indexOf(value) !== -1);
var globalCh = Radio.channel('global');

var ChangeTimeZoneOptionsView = Marionette.View.extend(DialogInterface).extend({
    template: Handlebars.compile(template),
    profile_page_template: Handlebars.compile(profile_page_template),
    ui: {
        form: 'form',
        submit: '.submit-time',
        load_spinner: '.loader',
    }, 
    events: {
        'click @ui.submit': 'selectedTimeZone',
    },
    initialize: function () {
        this.destroyOnClose();
        this.focusFirstInput();
    },
    templateContext: function() {
        // Timezone lists in the dropdown
        $(function() { 
            $("#timeSelector").append("<option>" + 'UTC' + "</option>");
            $("#timeSelector").append("<option>" + 'Set the timezone using Browser Timezone' + "</option>");
            $("#timeSelector").append("<option disabled>" + '---------------------------------' + "</option>");
            timezone.forEach(function(zone) {
                $("#timeSelector").append("<option>" + zone + "</option>");
            });
        });
        return timezone;
    },
    onRender: function() {
        ide_settings.fetch().done(this.show_sel_timezone); 
    },
    show_sel_timezone: function() {  
        var primary = globalCh.request('primary_account');
        var timezone = primary.get_timezone();
        return $("#timeSelector1").text(timezone); 
    },
    selectedTimeZone: function(e) { // gets the string
        e.preventDefault();
        var primary = globalCh.request('primary_account');
        var selected_timezone = $("#timeSelector  option:selected").text();
      
        var c = this.model.get('created_at');
        if (selected_timezone === 'Set the timezone using Browser Timezone') {
            // this formulae for moment.tz calculates the timezone of the browser according to the client's time
            var browser_selected_timezone = moment.tz.guess(new Date());
            c = moment(c).tz(browser_selected_timezone).format('YYYY-MM-DDTHH:mm:ss Z');
            $("#selected-time-zone").val('Set the timezone using Browser Timezone');
            primary.set_timezone(browser_selected_timezone);
        } else {
            c = moment(c).tz(selected_timezone).format('YYYY-MM-DDTHH:mm:ss Z');
            $("#selected-time-zone").val(selected_timezone);
            primary.set_timezone(selected_timezone);
        }
        $("#created-at-account").text(c);

        return selected_timezone;
    },
});

export default ChangeTimeZoneOptionsView;
